/* eslint-disable */
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link as MUILink, Theme, createStyles, makeStyles } from '@material-ui/core';
import { LinkProps } from '@material-ui/core/Link';
import cn from 'classnames';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    common: {
      paddingBottom: '4px',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'none',
        paddingBottom: '2px',
        borderBottom: `2px solid ${theme.palette.common.white}`,
      }
    },
    active: {
      textDecoration: 'none',
      paddingBottom: '2px',
      borderBottom: `2px solid ${theme.palette.common.white}`,
    },
    disabled: {

    }
  }));

const LinkComponent = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));

export function Link(props: LinkProps & RouterLinkProps & { disabled?: boolean, active?: boolean }) {
  const to = props.to || props.href;
  const target = '';
  const classes = useStyles(props);
  const { disabled, active } = props;
  const classname = cn(classes.common, props.className, {
    [classes.disabled]: disabled,
    [classes.active]: !!active
  });

  const onClick = (event: React.MouseEvent) => {
    if (disabled) {
      event.preventDefault();
    }

    if (props.onClick) {
      props.onClick(event as any);
    }
  }

  return <MUILink
    component={LinkComponent as any}
    target={target}
    {...props as LinkProps}
    to={to}
    className={classname}
    onClick={onClick}
  />;
}